import './App.css';
import './css/Home.css';
import './css/About.css';
import './css/OurCareGivers.css';
import './css/SpecialistCare.css';
import './css/Contact.css';
import './css/Services.css';
import './css/NewsDetails.css';
import './css/News.css';
import './css/Careers.css';
import './css/Admin.css';
import './css/AdminDashboard.css';
import CustomRouter from './components/CustomRouter';

function App() {
  return (
    <div className="App">
      <CustomRouter />
    </div>
  );
}

export default App;
